// This script enables keyboard selection (Enter/Space) for variant labels with tabindex="0"
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('label[tabindex="0"]').forEach(function(label) {
    label.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        const input = label.querySelector('input[type="radio"]');
        if (input && !input.checked && !input.disabled) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        e.preventDefault();
      }
    });
  });

  // Keyboard support for swatch spans with tabindex=0
  document.querySelectorAll('.swatch[tabindex="0"]').forEach(function(swatch) {
    swatch.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        // Find the closest parent label (for swatch inside label)
        let label = swatch.closest('label');
        if (label) {
          const input = label.querySelector('input[type="radio"]');
          if (input && !input.checked && !input.disabled) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        e.preventDefault();
      }
    });
  });
});
